import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
Vue.use(Vuex)

export default new Vuex.Store({
    // state: {
    //     count: 2
    // },
    // mutations: {
    // },
    // actions: {
    // },
    // modules: {
    // }
    modules: {
        user
    }
})



// WEBPACK FOOTER //
// ./src/store/index.js